import { Link } from "react-router-dom";
import Logo from "../components/brand/Logo";
import Badge from "../components/ui/Badge";
import Button from "../components/ui/Button";
import Card from "../components/ui/Card";

const steps = [
  ["Tell Me Your Vibe", "Answer a few quick questions about your mood, taste, and what you are in the mood for."],
  ["I Curate For You", "The Empress formula filters the catalog for shows and movies that fit your energy."],
  ["Get Your Picks", "See pitch lines, binge strategies, where to watch, and why each title matches."],
  ["Give Feedback", "Love it, meh, or nope so the next round gets sharper."],
];

const queenCharlottePoster =
  "https://image.tmdb.org/t/p/w342/e8KY5mvVD9dQlvQaCtyOjF1rCkN.jpg";

export default function Landing() {
  return (
    <div>
      <section className="mx-auto grid max-w-7xl gap-10 px-4 py-10 sm:px-6 lg:grid-cols-[1fr_440px] lg:items-center lg:px-8 lg:py-16">
        <div>
          <Logo size="hero" />
          <Badge variant="gold" className="mt-8">
            Your personal concierge to what's worth watching
          </Badge>
          <h1 className="mt-6 font-display text-6xl font-bold leading-none text-hookd-cream sm:text-7xl">
            Stop Scrolling.
            <span className="block text-hookd-gold">Start Watching.</span>
          </h1>
          <div className="hookd-divider my-7 max-w-md">♕</div>
          <p className="max-w-2xl text-lg leading-8 text-hookd-muted">
            Tell me your vibe, and I will handpick shows and movies just for you. Culturally curated, emotionally matched, and binge-worthy.
          </p>
          <div className="mt-8 grid gap-3 sm:flex">
            <Button as={Link} to="/quiz" size="lg" className="w-full sm:w-auto">
              Take the Vibe Quiz
            </Button>
            <Button as={Link} to="/login" variant="outline" size="lg" className="w-full sm:w-auto">
              I Already Have an Account
            </Button>
          </div>
          <div className="mt-6 flex flex-wrap gap-4 text-sm text-hookd-muted">
            <span>Private and secure</span>
            <span>Takes 2 minutes</span>
            <span>Personalized for you</span>
          </div>
        </div>

        <Card className="p-5" glow="purple">
          <div className="rounded-[28px] border border-hookd-empress/40 bg-hookd-ink p-5 shadow-neon">
            <p className="text-center text-xs font-bold uppercase text-hookd-gold">
              Your Empress Picks
            </p>
            <Card className="mt-5 p-4">
              <div className="mb-4 aspect-[4/3] overflow-hidden rounded-hookd border border-hookd-gold/30 bg-[linear-gradient(145deg,#2A173B,#08080F)]">
                <img
                  src={queenCharlottePoster}
                  alt="Queen Charlotte poster"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <h2 className="font-display text-3xl font-bold text-hookd-cream">
                Queen Charlotte
              </h2>
              <p className="mt-2 text-sm text-hookd-muted">Drama • Romance • Period</p>
              <div className="mt-4 space-y-3 text-sm leading-6 text-hookd-muted">
                <p>
                  <span className="font-bold text-hookd-gold">Why you'll love it:</span>{" "}
                  Royal drama with heart, power, and Black excellence.
                </p>
                <p>
                  <span className="font-bold text-hookd-gold">Binge strategy:</span>{" "}
                  Perfect for a weekend immersion.
                </p>
              </div>
            </Card>
          </div>
        </Card>
      </section>

      <section className="border-y border-hookd-line bg-white/[0.03] px-4 py-10 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <h2 className="text-center text-sm font-bold uppercase text-hookd-gold">
            How It Works
          </h2>
          <div className="mt-8 grid gap-5 md:grid-cols-4">
            {steps.map(([title, copy], index) => (
              <Card key={title} className="p-5 text-center">
                <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full border border-hookd-gold/40 bg-hookd-gold/10 font-display text-2xl text-hookd-gold">
                  {index + 1}
                </div>
                <h3 className="font-bold text-hookd-cream">{title}</h3>
                <p className="mt-3 text-sm leading-6 text-hookd-muted">{copy}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <Card className="grid gap-5 p-6 sm:grid-cols-[1fr_auto] sm:items-center">
          <div>
            <h2 className="font-display text-3xl font-bold text-hookd-cream">
              Ready for your next obsession?
            </h2>
            <p className="mt-2 text-hookd-muted">Let me find your perfect match.</p>
          </div>
          <Button as={Link} to="/quiz" variant="secondary" size="lg">
            Take the Vibe Quiz
          </Button>
        </Card>
      </section>
    </div>
  );
}
